import React, { useState, useCallback, useEffect } from 'react';
import JumboContentLayout from '@jumbo/components/JumboContentLayout';
import useJumboTheme from '@jumbo/hooks/useJumboTheme';
import {
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { ApiService } from 'app/servicesTwo/ApiService';
import { useParams, useLocation } from 'react-router-dom';
import CourseApprovalList from 'app/components/CourseApprovalList/CourseApprovalList';
import ContinuingCoursesList from 'app/components/ContinuingCoursesList/ContinuingCoursesList';
import CurrentCoursesAccordion from 'app/components/CurrentCoursesAccordion/CurrentCoursesAccordion';
import { CourseWithAllStatusList } from 'app/components/CourseWithAllStatusList/CourseWithAllStatusList';
import CompatibleCoursesList from 'app/components/CompatibleCoursesList/CompatibleCoursesList';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { GreatVibesRegular } from '../../../../assets/fonts/GreatVibes-regular';
import { capitalizeFLetter } from '@jumbo/utils';
// Componente fictício, apenas para ilustrar
import SpiritualAssistanceTrainingsList from 'app/components/SpiritualAssistanceTrainingsList/SpiritualAssistanceTrainingsList';

const ModalCourseHistory = ({ user, username, userId = null, handleClose }) => {
  const { theme } = useJumboTheme();
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  window.pdfMake.vfs['GreatVibes-Regular.ttf'] = GreatVibesRegular;
  pdfMake.fonts = {
    Roboto: {
      normal:
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
      bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
      italics:
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
      bolditalics:
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf',
    },
    GreatVibes: {
      normal: 'GreatVibes-Regular.ttf',
      bold: 'GreatVibes-Regular.ttf', // Se não houver versão 'bold', você pode usar a mesma
      italics: 'GreatVibes-Regular.ttf',
      bolditalics: 'GreatVibes-Regular.ttf',
    },
  };

  console.log(pdfMake);

  console.log(user);

  const lg = useMediaQuery(theme.breakpoints.down('lg'));
  const layoutOptions = React.useMemo(
    () => ({
      sidebar: {
        sx: {
          [theme.breakpoints.up('lg')]: {
            position: 'sticky',
            zIndex: 5,
            top: 96,
            minHeight: 'auto',
          },
          [theme.breakpoints.down('lg')]: {
            display: 'none',
          },
        },
      },
      wrapper: {
        sx: {
          alignItems: 'flex-start',
        },
      },
    }),
    [theme]
  );

  const { id } = useParams();
  const location = useLocation();

  const [courseHistory, setCourseHistory] = useState([]);
  const [courseHistoryOnlyApproval, setCourseHistoryOnlyApproval] = useState(
    []
  );
  const [courseHistoryFeespOnlyApproval, setCourseHistoryFeespOnlyApproval] =
    useState([]);
  const [courseHistoryOnlyActive, setCourseHistoryOnlyActive] = useState([]);
  const [coursesCompatible, setCoursesCompatible] = useState([]);
  const [coursesContinued, setCoursesContinued] = useState([]);
  const [modalTitle, setModalTitle] = useState('Histórico de Cursos');
  const [modalSubtitle, setModalSubtitle] = useState();
  const [activeComponent, setActiveComponent] = useState('initial');
  const [allDirectors, setAllDirectors] = useState([]);
  const [director, setDirector] = useState([]);
  const [directors, setDirectors] = useState([]);
  const [coursesSpiritualAssistance, setCoursesSpiritualAssistance] = useState([])
  const [coursesAIJM, setCoursesAIJM] = useState([])

  const currentPath = location.pathname;
  const inClassesURL =
    currentPath.startsWith('/app/editar-turma') ||
    currentPath.startsWith('/app/listar-cursos-outras-entidades') ||
    currentPath.startsWith('/app/listar-curso-lote') ||
    currentPath.startsWith('/app/listar-consultar-historico') ||
    currentPath.startsWith('/app/listar-avaliacao-de-documentos') ||
    currentPath.startsWith('/app/meus-dados');

  const idSelected = inClassesURL ? userId : id;

  const getCourseHistory = useCallback(async () => {
    try {
      ApiService.get(`/historico-cursos-feesp-outras-entidades/${idSelected}`)
        .then((response) => {
          console.log(response.data);
          setCourseHistory(response.data.historico_cursos);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getCourseHistoryOnlyFeespApproved = useCallback(async () => {
    try {
      ApiService.get(`/historico-cursos-feesp/${idSelected}?approved=${true}`)
        .then((response) => {
          console.log(response.data);
          const directorsList = response.data?.diretores || [];
          const ensinoDirector = directorsList.find(d => d.Area?.nome === 'ENSINO') || directorsList[0];
          setDirector(ensinoDirector);
          setAllDirectors(directorsList);
          setCourseHistoryFeespOnlyApproval(response.data?.historico_cursos);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getCourseHistoryWithApproval = useCallback(async () => {
    try {
      console.log('id selecionado', idSelected);
      ApiService.get(`/cursos-regulares-ativos/${idSelected}`)
        .then((response) => {
          console.log('sdsds', response);
          setCourseHistoryOnlyActive(response.data.cursosRegularesAtivos);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getCoursesRegular = useCallback(async () => {
    try {
      ApiService.get(`/cursos-regulares-continuados/${idSelected}`)
        .then((response) => {
          console.log(
            'redlkfjd',
            response.data?.historicoCursosRegulares?.historicoCursos
          );
          /* setCoursesCompatible(
            response.data?.historicoCursosRegulares?.historicoCursos
          ); */
          setCourseHistoryOnlyApproval(
            response.data?.historicoCursosRegulares?.historicoCursos
          );
          setCoursesContinued(
            response.data?.historicoCursosContinuados?.historicoCursos
          );
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getCourseHistoryFromSpiritualCenter = useCallback(async () => {
    try {
      ApiService.get(`/centro-espirita/historico-usuario/${idSelected}`)
        .then((response) => {
          console.log('cursos centro espirita compativeis', response.data);
          setCoursesCompatible(response.data.cursoHistoricoDoUsuario);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getCoursesAssistanceTraining = useCallback(async () => {
    try {
      ApiService.get(`/historico-cursos-feesp/${idSelected}?assistance=${true}`)
        .then((response) => {
          console.log('getCoursesAssistanceTraining', response.data);
          setCoursesSpiritualAssistance(response.data)
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getCourseHistoryAIJM = useCallback(async () => {
    try {
      ApiService.get(`/historico-cursos-feesp/${idSelected}?ijm=${true}`)
        .then((response) => {
          console.log('getCourseHistoryAIJM', response.data);
          setCoursesAIJM(response.data)
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleBackClick = () => {
    setActiveComponent('initial');
    setModalTitle('Histórico de Cursos');
    setModalSubtitle('');
  };

  const handleCompatibleCoursesClick = () => {
    setActiveComponent('compatible');
    setModalTitle('Histórico de Cursos Compatibilizados');
    setModalSubtitle('');
  };

  const handleDetailedHistoryClick = () => {
    setActiveComponent('detailedHistory');
    setModalTitle('Histórico Detalhado de Cursos');
    setModalSubtitle(
      'Somente constam dados de cursos realizados a partir de 2024'
    );
  };

  const handleSpiritualTrainingsClick = () => {
    setActiveComponent('spiritualTrainings');
    setModalTitle('Treinamentos na Assistência Espiritual');
    setModalSubtitle('Cursos realizados na área de Assistência Espiritual');
  };

  const handleAIJMClick = () => {
    setActiveComponent('aijm');
    setModalTitle('Cursos AIJM');
    setModalSubtitle('Cursos realizados na área de Mocidade');
  };

  const handleOthersClick = () => {
    setActiveComponent('others');
    setModalTitle('Outros');
    setModalSubtitle('Cursos cadastrados com o tipo "Outros"');
  };

  const renderHistoryButton = () => {
    return (
      <>
        {activeComponent === 'initial' && (
          <>
            <Button
            size='small'
            variant='contained'
            color='primary'
            style={{ marginRight: 10 }}
            onClick={handleAIJMClick}
          >
            Cursos AIJM
          </Button>
            <Button
              size='small'
              variant='contained'
              color='primary'
              style={{ marginRight: 10 }}
              onClick={handleCompatibleCoursesClick}
            >
              Cursos Compatibilizados
            </Button>
            <Button
              size='small'
              variant='contained'
              color='primary'
              style={{ marginRight: 10 }}
              onClick={handleSpiritualTrainingsClick}
            >
              Treinamentos na Assistência Espiritual
            </Button>
            <Button
              size='small'
              variant='contained'
              color='primary'
              style={{ marginRight: 10 }}
              onClick={handleOthersClick}
            >
              Outros
            </Button>
            <Button
              size='small'
              variant='contained'
              color='primary'
              style={{ marginRight: 10 }}
              onClick={handleDetailedHistoryClick}
            >
              Histórico Detalhado
            </Button>
          </>
        )}
      </>
    );
  };

  const renderContent = () => {
    switch (activeComponent) {
      case 'compatible':
        return <CompatibleCoursesList coursesCompatible={coursesCompatible} />;
      case 'detailedHistory':
        return (
          <CourseWithAllStatusList courseHistoryOnlyApproval={courseHistory} />
        );
      case 'spiritualTrainings':
        return (
          <SpiritualAssistanceTrainingsList
            trainings={coursesSpiritualAssistance?.historico_cursos}
            user={user}
            director={coursesSpiritualAssistance?.director}
          />
        );
      case 'aijm':
        return (
          <CourseWithAllStatusList courseHistoryOnlyApproval={coursesAIJM?.historico_cursos} />
        );
      case 'others':
        return (
          <CourseWithAllStatusList
            courseHistoryOnlyApproval={courseHistory?.filter(
              (c) => c?.Turma?.Curso?.tipo_curso === 'outros'
            )}
          />
        );
      default:
        return (
          <>
            <CurrentCoursesAccordion
              courseHistoryOnlyActive={courseHistoryOnlyActive}
            />
            <CourseApprovalList
              courseHistoryOnlyApproval={courseHistoryOnlyApproval}
              user={user}
              director={director}
            />
            <ContinuingCoursesList
              coursesContinued={coursesContinued}
              user={user}
            />
          </>
        );
    }
  };

  useEffect(() => {
    if (id || userId) {
      getCourseHistory();
      getCoursesRegular();
      getCourseHistoryWithApproval();
      getCourseHistoryFromSpiritualCenter();
      getCourseHistoryOnlyFeespApproved();
      getCourseHistoryOnlyFeespApproved();
      getCoursesAssistanceTraining()
      getCourseHistoryAIJM()
    }
  }, []);

  const loadImageBase64 = (path) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', path);
      xhr.responseType = 'blob';
      xhr.send();
    });
  };

  const generatePDF = async (historico, pessoa, diretores) => {
    const coursesByArea = historico.reduce((acc, item) => {
      const areaName = item.Turma?.Curso?.Departamento?.Areas?.nome || 'OUTROS';
      if (!acc[areaName]) {
        acc[areaName] = [];
      }
      acc[areaName].push(item);
      return acc;
    }, {});
  
    const areas = Object.keys(coursesByArea);
    const content = [];
  
    const logoBase64 = await loadImageBase64('/images/logositefeesp.png');
  
    for (let i = 0; i < areas.length; i++) {
        const areaName = areas[i];
        const areaCourses = coursesByArea[areaName];
        
        const areaDirector = diretores.find(d => d.Area?.nome === areaName) || diretores[0];
        
        const areaObj = areaCourses[0]?.Turma?.Curso?.Departamento?.Areas;
        const imageName = areaObj?.imagem_area;
        const areaPhone = areaObj?.telefone || '';
        const areaRamal = areaObj?.ramal || '';
        
        let iconAreaBase64 = null;
        if (imageName) {
            try {
               iconAreaBase64 = await loadImageBase64(`${process.env.REACT_APP_API_KEY}/images/${imageName}`);
            } catch (e) {
               console.warn("Could not load area image", imageName);
            }
        }
        
        let assinaturaBase64 = null;
        if (areaDirector?.assinatura) {
             try {
                assinaturaBase64 = await loadImageBase64(`${process.env.REACT_APP_API_KEY}/images/${areaDirector?.assinatura}`);
             } catch (e) {
                console.warn("Could not load signature", areaDirector?.assinatura);
             }
        }


        const cursosTable = areaCourses.map((item) => [
            { text: item.ano_de_conclusao ?? '-', alignment: 'center' },
            item.Turma.Curso.nome,
            { text: item.Turma?.Curso?.carga_horaria ?? '-', alignment: 'center' },
        ]);

        const pageContent = [
              {
                columns: [
                  {
                    image: logoBase64,
                    width: 200,
                    alignment: 'left',
                    margin: [0, 0, 0, 0],
                  },
                  { text: '', width: '*' },
                  iconAreaBase64
                    ? {
                        image: iconAreaBase64,
                        fit: [200, 23],
                        width: 200,
                        alignment: 'right',
                        margin: [0, 15, 0, 0],
                      }
                    : { text: '', width: 200 },
                ],
              },
              {
                text: '\nDECLARAÇÃO DE CURSOS REALIZADOS\n',
                style: 'header',
                alignment: 'center',
              },
              {
                text: [
                  'Declaramos, para os devidos fins, que ',
                  { text: pessoa.nome, bold: true, fontSize: 14 },
                  `, CPF ${
                    pessoa.cpf ?? '-'
                  }, concluiu os seguintes cursos em nossa instituição relacionados à área de `,
                  { text: areaName, bold: true },
                  ':'
                ],
                style: 'body',
              },
              {
                table: {
                  widths: ['auto', '*', 'auto'],
                  body: [
                    [
                      { text: 'ANO DE CONCLUSÃO', style: 'tableHeader' },
                      { text: 'CURSO', style: 'tableHeader' },
                      { text: 'CARGA HORÁRIA', style: 'tableHeader' },
                    ],
                    ...cursosTable,
                  ],
                },
                style: 'table',
              },
              {
                unbreakable: true,
                stack: [
                  {
                    text: '\nColocamo-nos à disposição para quaisquer esclarecimentos.',
                    style: 'body',
                  },
                  {
                    text: '\nAtenciosamente,\n',
                    style: 'body',
                  },
                  {
                    alignment: 'center',
                    stack: [
                      ...(assinaturaBase64
                        ? [
                            {
                              image: assinaturaBase64,
                              fit: [150, 80],
                            },
                            { text: '______________________________' },
                            {
                              text: `${areaDirector?.User?.nome || 'Diretoria'}`,
                              bold: true,
                            },
                            {
                              text: `Direção da Área de ${capitalizeFLetter(
                                areaName.toLowerCase()
                              )}`,
                            },
                          ]
                        : [
                            {
                              text: `Direção da Área de ${capitalizeFLetter(
                                areaName.toLowerCase()
                              )}`,
                            },
                          ]),
      
                      {
                        text: `Emitido em ${new Date().toLocaleDateString(
                          'pt-BR'
                        )}, às ${new Date().toLocaleTimeString('pt-BR')}, via sistema.${
                          areaPhone
                            ? ` Dúvidas: entrar em contato com a área de ${capitalizeFLetter(
                                areaName.toLowerCase()
                              )} pelo telefone ${areaPhone}${
                                areaRamal ? ` ramal ${areaRamal}` : ''
                              }`
                            : ''
                        }`,
                        fontSize: 10,
                        marginTop: 40,
                      },
                    ],
                  },
                ],
              },
        ];

        if (i < areas.length - 1) {
            pageContent[pageContent.length - 1].pageBreak = 'after';
        }
        
        content.push(...pageContent);
    }
  
    const docDefinition = {
        content: content,
        styles: {
          header: {
            fontSize: 14,
            bold: true,
            margin: [0, 10, 0, 10],
          },
          subheader: {
            fontSize: 12,
            margin: [0, 10, 0, 10],
          },
          body: {
            fontSize: 11,
            margin: [0, 10, 0, 10],
          },
          table: {
            margin: [0, 20, 0, 20],
          },
          tableHeader: {
            bold: true,
            fontSize: 10,
            color: 'black',
            fillColor: '#eeeeee',
          },
        },
      };

      pdfMake.createPdf(docDefinition).open();

  };

  return (
    <JumboContentLayout layoutOptions={layoutOptions}>
      {lg && (
        <Stack spacing={2} direction={'row'} sx={{ mb: 3, mt: -2 }}></Stack>
      )}
      <Paper sx={{ p: '40px', height: '500px' }}>
        <Box sx={{ height: '100%', overflowY: 'auto' }}>
          <Box
            display='flex'
            justifyContent='flex-end'
            alignItems='center'
            marginRight='1rem'
            gap={1}
          >
            {activeComponent !== 'initial' && (
              <Button
                size='small'
                variant='contained'
                color='success'
                onClick={handleBackClick}
              >
                Voltar
              </Button>
            )}
            <Button size='small' variant='contained' onClick={handleClose}>
              Fechar
            </Button>
            <Button
              size='small'
              variant='contained'
              color='success'
              disabled={
                courseHistoryFeespOnlyApproval.length === 0
              }
              onClick={() =>
                generatePDF(courseHistoryFeespOnlyApproval, user, allDirectors)
              }
            >
              Declaração de Cursos Realizados
            </Button>
          </Box>
          <Typography
            variant={'h1'}
            style={{ textAlign: 'center', marginBottom: 30 }}
          >
            {modalTitle}
          </Typography>
          {/* <Typography variant={'h5'} fontWeight={'bold'}>
            {modalSubtitle}
          </Typography> */}
          <Box display={'flex'} gap={1} alignItems={'center'}>
            <Typography variant='h4' fontWeight={'300'}>
              Aluno selecionado:
            </Typography>

            <Typography
              variant='h4'
              textTransform={'capitalize'}
              fontWeight={'600'}
            >
              {username}
            </Typography>
          </Box>
          <Box
            display='flex'
            justifyContent='end'
            alignItems='center'
            marginBottom='1rem'
          >
            {renderHistoryButton()}
          </Box>
          <React.Fragment>{renderContent()}</React.Fragment>
        </Box>
      </Paper>
    </JumboContentLayout>
  );
};

export default ModalCourseHistory;
